
interface StatusOption {
    value: string;
    label: string;
    color: string;
    count?: number;
}

interface StatusFilterProps {
    options: StatusOption[];
    selectedStatuses: string[];
    onChange: (statuses: string[]) => void;
    title?: string;
}

const StatusFilter = ({ options, selectedStatuses, onChange, title = "Status" }: StatusFilterProps) => {
    const toggleStatus = (status: string) => {
        const newStatuses = selectedStatuses.includes(status)
            ? selectedStatuses.filter(s => s !== status)
            : [...selectedStatuses, status];
        onChange(newStatuses);
    };

    const getStatusColor = (color: string, isSelected: boolean) => {
        const colors = {
            'PENDING': isSelected ? 'bg-slate-500 text-white' : 'bg-slate-100 text-slate-700 hover:bg-slate-200',
            'CHECKING': isSelected ? 'bg-slate-600 text-white' : 'bg-slate-100 text-slate-700 hover:bg-slate-200',
            'SENT': isSelected ? 'bg-green-600 text-white' : 'bg-green-100 text-green-700 hover:bg-green-200',
            'DELIVERED': isSelected ? 'bg-green-700 text-white' : 'bg-green-100 text-green-700 hover:bg-green-200',
            'RECEIVED': isSelected ? 'bg-blue-600 text-white' : 'bg-blue-100 text-blue-700 hover:bg-blue-200',
            'ERROR': isSelected ? 'bg-red-600 text-white' : 'bg-red-100 text-red-700 hover:bg-red-200',
            'FAILED': isSelected ? 'bg-red-700 text-white' : 'bg-red-100 text-red-700 hover:bg-red-200',
            'CANCELLED': isSelected ? 'bg-orange-600 text-white' : 'bg-orange-100 text-orange-700 hover:bg-orange-200',
        };
        return colors[color as keyof typeof colors] || (isSelected ? 'bg-gray-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200');
    };

    return (
        <div className="space-y-2">
            <h4 className="text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
                {title}
            </h4>
            <div className="flex flex-wrap gap-1">
                {options.map((option) => {
                    const isSelected = selectedStatuses.includes(option.value);
                    return (
                        <button
                            key={option.value}
                            onClick={() => toggleStatus(option.value)}
                            className={`
                                inline-flex items-center px-2 py-1 rounded-full text-xs font-medium transition-all duration-200
                                ${getStatusColor(option.color, isSelected)}
                                ${isSelected ? 'shadow-md transform scale-105' : 'shadow-sm hover:shadow-md'}
                            `}
                        >
                            {option.label}
                            {option.count !== undefined && (
                                <span className={`ml-1 px-1.5 py-0.5 rounded-full text-xs ${isSelected ? 'bg-white/20' : 'bg-black/10'
                                    }`}>
                                    {option.count}
                                </span>
                            )}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default StatusFilter;
